import { Application } from 'pixi.js'
import { debounce, cloneDeepWith } from 'lodash'
import { emitResources } from '@/utils/event'
import { 
    RES_CONFIG,
    DESIGN_WIDTH,
    DESIGN_HEIGHT,
    CANVAS_RATE_MIN,
    ROOT_MARGIN_LEFT,
    ROOT_MARGIN_RIGHT } from '../config'

export default class PixiLoader {
    constructor(rootElement) {
        this.rootElement = rootElement
        this.app = null
    }

    createApplication() {
        const app = new Application({
            autoResize: true,
            resolution: window.devicePixelRatio || 1,
            antialias: true,
            transparent: true,
            resizeTo: this.rootElement
        });
        app.renderer.plugins.interaction.autoPreventDefault = false;
        app.renderer.view.style.touchAction = 'auto';
      
        this.rootElement.appendChild(app.view);
        this.app = app;
      
        window.addEventListener('resize', debounce(() => {
            this._resizePixiArea();
        }, 200))
      
        this._resizePixiArea();
        return this.app;
    }

    async loadResources() {
        // console.log('loadResources')
        return new Promise((resolve, reject) => {
            let loaderIns = this.app.loader;
            for (const res of this._getResPathList()) {
                // console.log(res)
                loaderIns = loaderIns.add(res.name, res.path)
            }
            loaderIns.onProgress.add((loader) => {
                // console.log("progress: " + loader.progress + "%");
                emitResources(parseInt(loader.progress))
            })
            loaderIns.load((loader, resources) => {
                // console.log(resources)
                for (let key in resources) {
                    if (resources[key].error) {
                        // console.log('loadResources failed')
                        // console.log(resources[key])
                        reject();
                        return;
                    }
                }
                // console.log('loadResources success')
                emitResources(100)
                resolve()
            });
        })
    }

    _calcSizeByDesign() {
        const rootWidth = window.innerWidth + ROOT_MARGIN_LEFT;
        const rootHeight = window.innerHeight + ROOT_MARGIN_RIGHT;
    
        const canvasWidthMin = DESIGN_WIDTH * CANVAS_RATE_MIN
        
        const fixedWidth = rootWidth < canvasWidthMin ? canvasWidthMin : rootWidth;
        const fixedHeight = rootHeight;
    
        const scaleWidthExpected = fixedWidth / DESIGN_WIDTH
        const scaleHeightExpected = fixedHeight / DESIGN_HEIGHT
        const scaleRate = Math.min(scaleWidthExpected, scaleHeightExpected);
    
        const widthReal = scaleWidthExpected > scaleHeightExpected ? DESIGN_WIDTH * scaleRate : fixedWidth;
        const heightReal = scaleWidthExpected < scaleHeightExpected ? DESIGN_HEIGHT * scaleRate : fixedHeight;
    
        return { widthReal, heightReal, scaleRate };
    }

    _resizePixiArea() {
        if (!this.app || !this.app.stage) {
            return
        }
        // console.log('resizeCanvas')
        const { widthReal, heightReal, scaleRate } = this._calcSizeByDesign();
    
        this.rootElement.style.width = `${parseInt(widthReal)}px`
        this.rootElement.style.height = `${parseInt(heightReal)}px`
    
        this.app.stage.scale.x = scaleRate
        this.app.stage.scale.y = scaleRate
        
        document.getElementById('radius').style.width = widthReal > heightReal ? `${parseInt(widthReal)}px` : `${parseInt(heightReal)}px`
        document.getElementById('radius').style.height = widthReal > heightReal ? `${parseInt(widthReal)}px` : `${parseInt(heightReal)}px`

        this.app.resize(widthReal, heightReal);
    }

    _getResPathList() {
        let resList = [];
        // recursively
        cloneDeepWith(RES_CONFIG, (item, name) => {
            const { path, type } = item
            if (path && type) {
                resList.push({ path, type, name})
            }
        })

        return resList;
    }
}
